import { Box, styled } from "@mui/material"
import jasmine from "assets/products/objects/blue/jasmine-flowers.png"
import cupcake from "assets/products/objects/blue/cupcake-with-fresh-strawberries.png"
import vanillaFlower from "assets/products/objects/blue/vanilla-flower.webp"
import vanillaBean from "assets/products/objects/blue/vanila-bean.png"

import slicedLime from "assets/products/objects/pink/sliced_lime.png"
import lime from "assets/products/objects/pink/fresh-lime.png"
import strawberry from "assets/products/objects/pink/strawberry.png"
import strawberry2 from "assets/products/objects/pink/strawberry2.png"

import raspberry from "assets/products/objects/purple/raspberry.png"
import rasberry from "assets/products/objects/purple/roseberry.png"
import blackRasberry from "assets/products/objects/purple/black-rasberry.png"
import ripeBerries from "assets/products/objects/purple/ripe-berries.png"

import pineapple from "assets/products/objects/yellow/pineapple.png"
import pineappleSlice from "assets/products/objects/yellow/pineapple-slide.png"
import coconut1 from "assets/products/objects/yellow/coconut-1.png";
import coconut2 from "assets/products/objects/yellow/coconut-2.png";
function Objects() {
  return (
    <ObjectImages>
      <img src={lime} alt="" />
      <img src={rasberry} alt="" />
      <img src={coconut2} alt="" />
      <img src={blackRasberry} alt="" />
      <img src={vanillaFlower} alt="" />
      <img src={strawberry} alt="" />
      <img src={pineappleSlice} alt="" />
      <img src={ripeBerries} alt="" />
      <img src={coconut1} alt="" />
      <img src={jasmine} alt="" />
      <img src={slicedLime} alt="" />
      <img src={coconut2} alt="" />
      {/* <img src={cupcake} alt="" /> */}
      <img src={vanillaBean} alt="" />
      <img src={strawberry2} alt="" />
    </ObjectImages>
  )
}



const ObjectImages = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  height: "100%",
  width: "100%",
  img: {
    width: 100,
    position: "absolute",
    transform: "translate(-50%, -50%)",
    opacity: "0.3",
    // filter: "drop-shadow(2px 4px 6px black)",

    ":nth-child(1)": {
      left: "10%",
      top: "5%"
    },

    ":nth-child(2)": {
      left: "50%",
      top: "0%",
      width: 150,
      [theme.breakpoints.down('md')]: {
        width: 120,
      }
    },

    ":nth-child(3)": {
      left: "95%",
      top: "25%",
      width: 160,
      [theme.breakpoints.down('md')]: {
        width: 130,
      }
    },

    ":nth-child(4)": {
      left: "0",
      top: "35%",
      width: 190,
      [theme.breakpoints.down('md')]: {
        width: 160,
      }
    },

    ":nth-child(5)": {
      left: "50%",
      top: "45%",
      width: 190,
      [theme.breakpoints.down('md')]: {
        width: 160,
      }
    },

    ":nth-child(6)": {
      left: "80%",
      top: "60%",
      width: 170,
      transform: "translate(-50%, -50%) rotate(-90deg)",
      [theme.breakpoints.down('md')]: {
        width: 140,
      },
    },

    ":nth-child(7)": {
      left: "50%",
      top: "70%",
      width: 150,
      [theme.breakpoints.down('md')]: {
        width: 120,
      }
    },

    ":nth-child(8)": {
      left: "10%",
      top: "70%",
      width: 120,
      [theme.breakpoints.down('md')]: {
        width: 90,
      }
    },

    ":nth-child(9)": {
      left: "100%",
      top: "85%",
      width: 120,
      [theme.breakpoints.down('md')]: {
        width: 90,
      }
    },

    ":nth-child(10)": {
      left: "10%",
      top: "93%",
      width: 150,
      [theme.breakpoints.down('md')]: {
        width: 120,
      }
    },

    ":nth-child(11)": {
      left: "70%",
      top: "95%",
      width: 160,
      [theme.breakpoints.down('md')]: {
        width: 130,
      }
    },
    ":nth-child(12)": {
      left: "30%",
      top: "30%",
      width: 160,
      [theme.breakpoints.down('md')]: {
        display: "none"
      }
    },
    ":nth-child(13)": {
      left: "70%",
      top: "30%",
      width: 160,
      [theme.breakpoints.down('md')]: {
        display: "none"
      }
    },
    ":nth-child(14)": {
      left: "30%",
      top: "102%",
      width: 210,
      [theme.breakpoints.down('md')]: {
        display: "none"
      }
    }
  }
}))

export default Objects